import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { TourDirections } from 'pages/tours/main-page/components/tour-directions'

import { flightSearchesStore } from 'widgets/avia'
import { NearFlight } from 'widgets/avia/near-flight/ui'
import { PopularDirections } from 'widgets/avia/popular-directions/ui'
import { PromotionsBlock } from 'widgets/avia/promotions/ui'
import { SearchFormCopy } from 'widgets/avia/search-form-copy'
import { HeaderTabs } from 'widgets/header-tabs'
import { CountAndClass } from 'widgets/level-class-count'

// import { CertificateBanner } from 'entities/sales/components/certificate-banner'
import findTicketFormStore from 'entities/ticket/models/find-ticket/find-ticket-store'
import formPassengersStore from 'entities/ticket/models/form-passengers/form-passengers-store'
import listTicketsStore from 'entities/ticket/models/list-tickets/list-tickets-store'

import { BottomNavigation } from 'shared/ui/bottom-navigation'
import { Paper } from 'shared/ui/paper'

import { ComplexRoute } from './components/complex-route'
import { TripServices } from './components/trip-services'
import s from './styles.module.scss'

const MainPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    formPassengersStore.clearValuesForm()
    listTicketsStore.resetListOfTicket()
    void flightSearchesStore.ensureSearches()
  }, [])

  // const goToDifficultRoute = () => {
  //   navigate(RoutingPaths.avia.difficultRoute.path())
  // }

  const onSwitchDirections = () => {
    findTicketFormStore.onSwitchDirection(0)
  }

  const onChange = (data?: CountAndClass) => {
    findTicketFormStore.onSetCountAndClass(data)
  }

  const onSearch = () => {
    navigate(RoutingPaths.avia.search.path())
  }

  const onGoToTours = () => {
    navigate(RoutingPaths.tours.path())
  }

  return (
    <div className={clsx('bgGrey', s.container)}>
      <HeaderTabs module="avia" />
      <Paper
        padding={[16]}
        radius="28px"
        className={s.paper}
      >
        {/* <div className={s.box}>
          <p className={s.title}>{t('main_page.title')}</p>
          <p className={s.subTitle}>{t('main_page.sub_title')}</p>
        </div> */}

        <SearchFormCopy
          searchData={findTicketFormStore.formFindTicket}
          onSwitch={onSwitchDirections}
          onChange={onChange}
          onSearch={onSearch}
          type={'lightGrey'}
        />

        <ComplexRoute
          goToDifficultRoute={() =>
            navigate(RoutingPaths.avia.difficultRoute.path())
          }
        />
      </Paper>

      <div className={s.banners}>
        {/* <CertificateBanner /> */}
        <NearFlight />

        <TripServices />

        <div className={s.promotions}>
          <PromotionsBlock type={'avia'} />
        </div>
      </div>

      {/* <FastActions
        orderUrl={RoutingPaths.avia.myTickets.path()}
        supportUrl={RoutingPaths.feedback.path()}
      /> */}

      <div className={s.popularDirection}>
        <PopularDirections />
      </div>

      <div className={s.tours}>
        <TourDirections
          isMainPage
          title={t('main_page_action.title')}
          linkText={t('main_page_action.link_text')}
          button={{
            buttonTitle: t('main_page_action.button_title'),
            actionButton: onGoToTours,
          }}
        />
      </div>

      <BottomNavigation activeId="home" />
    </div>
  )
})

export default MainPage
